function initOgcCollectionsShop() {

  document.querySelectorAll('.ogc-shop-sidebar__inner').forEach(function (sidebar) {
    var node = sidebar.parentElement;

    while (node && node !== document.body && node !== document.documentElement) {
      var style = window.getComputedStyle(node);

      if (/(hidden|clip|auto|scroll)/.test(style.overflow + style.overflowX + style.overflowY)) {
        node.style.setProperty('overflow', 'visible', 'important');
        node.style.setProperty('overflow-x', 'visible', 'important');
        node.style.setProperty('overflow-y', 'visible', 'important');
      }

      node = node.parentElement;
    }
  });

  document.querySelectorAll('.ogc-shop-swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      var card = swatch.closest('.ogc-shop-card');
      if (!card) return;

      var image = card.querySelector('[data-ogc-product-image]');
      var newImage = swatch.getAttribute('data-variant-image');

      if (image && newImage) {
        image.src = newImage;
        image.srcset = '';
      }

      card.querySelectorAll('.ogc-shop-swatch').forEach(function (item) {
        item.classList.remove('active');
      });

      swatch.classList.add('active');
    });
  });

  document.querySelectorAll('.ogc-shop-card[data-url]').forEach(function (card) {
    card.addEventListener('click', function (event) {
      if (event.target.closest('a, button')) return;
      window.location.href = card.getAttribute('data-url');
    });
  });

  var navLinks = document.querySelectorAll(
    '.ogc-shop-side-link, .ogc-shop-mobile-pill, .ogc-shop-cta-customise'
  );
  var sections = document.querySelectorAll('.ogc-shop-category');

  function setActive(id) {
    navLinks.forEach(function (link) {
      link.classList.toggle('active', link.getAttribute('href') === '#' + id);
    });
  }

  function updateActiveSection() {
    var currentId = sections[0] ? sections[0].id : '';

    sections.forEach(function (section) {
      var rect = section.getBoundingClientRect();
      if (rect.top <= 170) currentId = section.id;
    });

    if (currentId) setActive(currentId);
  }

  var ticking = false;

  function update() {
    if (ticking) return;

    ticking = true;
    requestAnimationFrame(function () {
      updateActiveSection();
      ticking = false;
    });
  }

    navLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
        e.preventDefault();

        var id = link.getAttribute('href').replace('#', '');
        var target = document.getElementById(id);

        if (!target) return;

        setActive(id);

        window.scrollTo({
        top: target.offsetTop - 110, // adjust for your sticky header
        behavior: 'smooth'
        });

        history.replaceState(null, '', window.location.pathname + window.location.search);
    });
    });

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('load', update);

  update();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOgcCollectionsShop);
} else {
  initOgcCollectionsShop();
}